(function(){
    angular
        .module('appback')
        .directive('ngBiopsianew', biopsianew);

        biopsianew.$inject = ['GenerallabService','ResultadosService','$timeout'];
        function biopsianew(GenerallabService,ResultadosService,$timeout){
            return {
	            //require: 'ngModel',
	            templateUrl: '/backend/resultadopeticion/template?name=biopsianew.twig',
		          scope: {
                  //ngModel : '=',
                  item: '=',
                  animal: '=',
                  centro: '='
              	},
            	link: function (scope, element, $attrs) {
		            return $timeout(function () {
						scope.escanerData = [];
						scope.generalLab = GenerallabService;
		            	scope.loadingFields = false;
		            	//console.log(scope.item.resultado);
		            	if(!scope.item.resultado){
			            		scope.item.resultado = { extra : { resultado : { nodulos : [{ recuento_mitotico:'10hpf' }], pruebas_complementarios:[] }}};
		            	}else{
			            	if(!scope.item.resultado.extra){
			            		scope.item.resultado.extra = { resultado : { nodulos : [{ recuento_mitotico:'10hpf' }], pruebas_complementarios:[] }};
				            }
				        }

						scope.parseUrl = function(url) {
							// Reemplazar \\T\\ con &
							url = url.replace(/\\T\\/g, '&');
							
							// Eliminar ^^IM^MRXS del final
							url = url.replace(/\^\^IM\^MRXS$/, '');
							
							// Decodificar la URL
							url = decodeURIComponent(url);
							
							return url;
						};

						scope.getEscaner = function() {
                            ResultadosService.getEscaner(scope.item.peticion_id)
                                .then(function(response) {
									console.log("response escáner: ",response.data);
                                    scope.escanerData = response.data;
                                    console.log('Datos del escáner:', scope.escanerData);
                                })
                                .catch(function(error) {
                                    console.error('Error al obtener datos del escáner:', error);
                                    scope.loadingEscaner = false;
                                });
                        };

                        // Llamar a la función cuando se carga la directiva
                        scope.getEscaner();


		            	function format(icon) {
	                        var originalOption = icon.element;
	                          var str = "";
	                          if(typeof $(originalOption).data('icon') != 'undefined'){
	                            str+='<i class="icon alt'+$(originalOption).data('icon')+'"></i> <span>'+icon.text+'</span>';
	                            return $(str+" ");
	                          }else{
	                            return icon.text || icon.value;
	                          }
	                     }

	                     scope.pruebaComplementaria = function(){
	                     	if(typeof(scope.item.resultado.extra.resultado.pruebas_complementarios)=='undefined'){
	                     		scope.item.resultado.extra.resultado.pruebas_complementarios = [];
	                     	}
	                     	scope.item.resultado.extra.resultado.pruebas_complementarios.push({"analitica_id":""});
	                     }

	                     scope.borrarNodulo = function(index){
	                     	scope.item.resultado.extra.resultado.nodulos.splice(index,1);
	                     }

	                     scope.nuevoNodulo = function(){
	                     	scope.item.resultado.extra.resultado.nodulos.push({});
	                     }

	                     scope.buscarplantillamargen = function(nod){
	                     	scope.loadingFields = true;
	                     	ResultadosService.getPlantillaMargen(nod.valoracion_margenes,scope.centro.idioma_code,function(data){
                     			if(data.plantilla){
                     				nod = angular.merge(nod, data.plantilla);
                     			}
	                     		scope.loadingFields = false;
                     			//console.log(data);
				               //scope.subanaliticas = data.subanaliticas;
				            });
	                     }
	                   

	                     scope.comprobarDiag = function(nod){
	                     	//console.log(nod);
							console.log("NOD", nod);
	                     	if(nod.diagnostico){
	                     		//COMPROBAMOS SI TENEMOS QUE RELLENAR
	                     		ResultadosService.getDiagnosticoBiopPlantilla(nod.diagnostico,scope.centro.idioma_code,function(data){
									console.log("data receivced sadfasdf", data.plantilla.busqueda)
	                     			if(data.plantilla){
	                     				nod = angular.merge(nod, data.plantilla);
	                     				/*scope.loadingFields = true;
	                     				$timeout(function(){

	                     					scope.loadingFields = false;
	                     				})*/
	                     			}
	                     			//console.log(data);
					               //scope.subanaliticas = data.subanaliticas;
					            });

	                     	}
	                     }

						 scope.comprobarBusq = function(nod){
							//console.log(nod);
						   console.log("NOD BUSQ", nod);
							if(nod.busqueda){
								//COMPROBAMOS SI TENEMOS QUE RELLENAR
								ResultadosService.getDiagnosticoBiopPlantilla(nod.busqueda,scope.centro.idioma_code,function(data){
								   console.log("data receivced sadfasdf", data.plantilla.busqueda)
									if(data.plantilla){
										nod = angular.merge(nod, data.plantilla);
										nod.diagnostico = nod.busqueda;
										/*scope.loadingFields = true;
										$timeout(function(){

											scope.loadingFields = false;
										})*/
									}
									//console.log(data);
								  //scope.subanaliticas = data.subanaliticas;
							   });

							}
						}
				
	                     scope.optionsSelect2 = { 
		            		ajax: {
		                        url: "/backend/altcrm/content/select2",
		                        dataType: 'json',
		                        delay: 250,
		                        data: function (params) {
		                          return {
		                            q: params.term, // search term
		                            page: params.page,
		                            field: 'nombre',
		                            per_page: 20,
		                            //nodetype:'microorganismo'
		                          };
		                        },
		                        processResults: function (data, params) {
		                          params.page = params.page || 1;
		                          return {
		                            results: data.items,
		                            pagination: {
		                              more: (params.page * 1) < data.total_count
		                            }
		                          };
		                        },
		                        cache: true
		                    },
		                    templateSelection: format,
		                    templateResult: format
	                	};

		            	scope.optionsAtributos = {
	                		ajax: {
		                        url: "/backend/resultadopeticion/select2atributos",
		                        dataType: 'json',
		                        delay: 250,
		                        data: function (params) {
		                          return {
		                            q: params.term, // search term
		                            page: params.page,
		                            field: 'nombre',
		                            per_page: 20,
		                            nodetype:'valoresatt'
		                          };
		                        },
		                        processResults: function (data, params) {
		                          params.page = params.page || 1;
		                          return {
		                            results: data.items,
		                            pagination: {
		                              more: (params.page * 1) < data.total_count
		                            }
		                          };
		                        },
		                        cache: true
		                    },
		                    templateSelection: format,
		                    templateResult: format
	                	}
			        });
					
		        }
          }
      }
})();